export const fileToAttachment = (file, callback) => {
  const reader = new FileReader()
  reader.onload = function (event) {
    const attachment = {
      data: event.target.result,
      filename: file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
      content_type: file.type,
      identify: false
    }
    callback(attachment)
  }
  reader.readAsDataURL(file)
}
